import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class CourierContract extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/courier/contract'
    super(store, path)
  }
}
